"use client";

import { useTheme } from "./ThemeProvider";

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  const isDark = theme === "dark";
  const tooltipText = isDark ? "Switch to light theme" : "Switch to dark theme";

  return (
    <div className="group relative flex">
      {/* Tooltip — left and below switcher so it stays visible on page */}
      <span
        className="pointer-events-none absolute right-0 top-full mt-2 whitespace-nowrap rounded-xl bg-slate-800/95 px-4 py-2.5 text-sm font-medium tracking-wide text-white shadow-xl ring-1 ring-white/10 backdrop-blur-sm opacity-0 transition-opacity duration-200 delay-300 group-hover:opacity-100 dark:bg-white/95 dark:text-slate-900 dark:ring-slate-200/20"
        role="tooltip"
      >
        {tooltipText}
        {/* Arrow pointing up at the button */}
        <span
          className="absolute left-1/2 bottom-full -translate-x-1/2 translate-y-1/2 h-3 w-3 rotate-45 rounded-sm bg-slate-800/95 ring-1 ring-white/10 dark:bg-white/95 dark:ring-slate-200/20"
          aria-hidden
        />
      </span>
      <button
        type="button"
        onClick={toggleTheme}
        aria-label={tooltipText}
        className="flex h-4 w-7 shrink-0 items-center rounded-full bg-white/50 ring-1 ring-white/40 backdrop-blur-xl transition-colors hover:bg-white/60 dark:bg-white/10 dark:ring-white/20 dark:hover:bg-white/15"
      >
        <span
          className="flex h-2.5 w-2.5 shrink-0 translate-x-0.5 items-center justify-center rounded-full bg-white shadow transition-transform dark:translate-x-3.5 dark:bg-slate-800"
          aria-hidden
        >
          {isDark ? (
            <svg className="h-1.5 w-1.5 text-amber-400" fill="currentColor" viewBox="0 0 20 20" aria-hidden>
              <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
            </svg>
          ) : (
            <svg className="h-1.5 w-1.5 text-slate-600 dark:text-white/70" fill="currentColor" viewBox="0 0 20 20" aria-hidden>
              <path
                fillRule="evenodd"
                d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                clipRule="evenodd"
              />
            </svg>
          )}
        </span>
      </button>
    </div>
  );
}
